import * as THREE from 'three';
import { createRenderer, Pipeline } from './core/pipeline.js';
import { Player } from './core/controller.js';
import { buildGame } from './game/game.js';

const canvas = document.getElementById('view');
const renderer = createRenderer(canvas);

const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.05, 400);
scene.add(camera);

// Kosketuslaitteilla Pointer Lock API ei toimi luotettavasti kosketuksesta (osa
// mobiiliselaimista ei myönnä sitä ollenkaan) — player.touchActive toimii sen
// korvikkeena niin ettei peli jää ikuisesti "ei lukittu" -tilaan. game.js kutsuu
// onRequestExit-koukkua kun tarina päättyy ja gate-ruutu pitää näyttää uudelleen.
const game = buildGame(scene, { onRequestExit: () => asetaKaynnissa(false) });
const player = new Player(camera, game.colliders, game.spawn);
if (typeof game.yaw === 'number') player.yaw = game.yaw;

const gate = document.getElementById('gate');
const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

function asetaKaynnissa(kaynnissa) {
  gate.classList.toggle('hidden', kaynnissa);
  document.body.classList.toggle('playing', kaynnissa);
  player.touchActive = kaynnissa;
  game.onLockChange?.(kaynnissa);
}

const actions = {
  onLockChange: asetaKaynnissa,
  onPrimaryDown: () => game.onPrimaryDown?.(),
  onPrimaryUp: () => game.onPrimaryUp?.(),
  onSecondaryDown: () => game.onSecondaryDown?.(),
  onSecondaryUp: () => game.onSecondaryUp?.(),
  onKeyDown: (code) => game.onKeyDown?.(code),
};
player.bindInput(canvas, actions);
player.bindTouch(actions);

gate.addEventListener('click', () => {
  if (isTouch) asetaKaynnissa(true);
  else canvas.requestPointerLock();
});

const pipeline = new Pipeline(renderer, scene, camera, 'high');
pipeline.resize();
window.addEventListener('resize', () => pipeline.resize());

const notes = document.getElementById('notes');
if (pipeline.warnings.length) notes.textContent = pipeline.warnings.join(' ');

// Headless-testien koukku (ks. peli-testi-skilli) — kasvaa templatesta.
window.__peli = { player, game, get scene() { return scene; }, get camera() { return camera; } };

// Rajattu reaaliaika-dt (ei kiinteän aika-askeleen accumulator) — ks. core/controller.js:n
// yläkommentti siitä miksi FPS-kontrolleri poikkeaa muiden pohjien konventiosta.
const clock = new THREE.Clock();
function looppi() {
  requestAnimationFrame(looppi);
  const dt = Math.min(0.05, clock.getDelta());
  const locked = isTouch ? player.touchActive : document.pointerLockElement === canvas;
  if (!locked) { player.keys.clear(); player.mouseDelta.set(0, 0); }

  const move = player.update(dt, { aiming: false });
  game.update?.(dt, { player, move, locked });
  pipeline.render(dt);
}
requestAnimationFrame(looppi);
